import { FormGroup, FormBuilder } from "@angular/forms";

export class M_MEMBER_LEVEL {
    no : number = 0;
    hQ_CD: string = '';
    stR_CD: string = '';

    membeR_TP: string = '';
    membeR_TP_NM: string = '';

    membeR_TP_PRICE: number = 0;
    membeR_TP_CNT: number = 0;
    membeR_SAVE_RATE: number = 0;
    membeR_DICOUNT_RATE: number = 0;

    remark: string | null = null;
    usE_YN: string = 'Y';

    inserT_DT: Date | null = null;
    inserT_USER: string | null = null;
    updatE_DT: Date | null = null;
    updatE_USER: string | null = null;
    newFG : boolean = false;

    constructor(init?: Partial<M_MEMBER_LEVEL>) {
        Object.assign(this, init);
    }

    toJSON(): any {
        const obj: any = {};

        Object.keys(this).forEach(key => {
            const value = (this as any)[key];

             obj[key] = value ?? null;
        });

        return obj;
    }

    fromJSON(json: any): M_MEMBER_LEVEL {
        return new M_MEMBER_LEVEL(json);
    }

    getAll(res: any[]): M_MEMBER_LEVEL[] {
        return (res ?? []).map(e => new M_MEMBER_LEVEL(e));
    }

    createForm(fb: FormBuilder): FormGroup {
        return fb.group({
            hQ_CD: [''],
            stR_CD: [''],
            membeR_TP: [''],
            membeR_TP_NM: [''],
            membeR_TP_PRICE: [0],
            membeR_TP_CNT: [0],
            membeR_SAVE_RATE: [0],
            membeR_DICOUNT_RATE: [0],
            remark: [null],
            usE_YN: ['Y']
        });
    }

    /** yyyyMMddHHmmss */
    formatDateTime(dateString: string): string {
        const date = new Date(dateString);

        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        const hh = String(date.getHours()).padStart(2, '0');
        const mm = String(date.getMinutes()).padStart(2, '0');
        const ss = String(date.getSeconds()).padStart(2, '0');

        return `${y}${m}${d}${hh}${mm}${ss}`;
    }

    parseISODate(value: string): Date | null {
        if (!value) return null;
        return new Date(value);
    }
}